import { render } from "./LessonPage.vue?vue&type=template&id=b527018a&scoped=true"
import script from "./LessonPage.vue?vue&type=script&lang=js"
export * from "./LessonPage.vue?vue&type=script&lang=js"

import "./LessonPage.vue?vue&type=style&index=0&id=b527018a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b527018a"]])

export default __exports__